<template>
	<div id="formateador" class="container">

	<H2>Crear Formato de 
		<br>un Contrato o de un Pre-Contrato
		<br>para imprimir
	</H2>
	<br>
	<a @click="$router.go(-1)">regresar</a>
	<br><br>
	<p>
	  	<hijo1 v-if='buscar' v-on:eventoConYpre= 'recibeC(...arguments)'>Cargando contratos...</hijo1>
	 </p>
		<div id = "esVisible">	
				<table align="center">
					<tr>
						<td>
							Contrato num.  
						</td>
						<td>
							<input type="text" id="contra" v-model='contratoSolo.id' disabled >
							<input type="button" v-on:click='aBuscar' name="bus" value="Buscar" >
						</td>
					</tr>
					<tr>
					</tr>
					<tr>
						<td>
							{{this.contratoSolo.inquilino}}
						</td>
						<td>
							{{this.contratoSolo.giro}}
						</td>

					</tr>
					<tr>
						<td>
							{{this.contratoSolo.propiedad}} {{this.contratoSolo.familia}}
						</td>
						<td>
							{{this.contratoSolo.nombreComercial}}
						</td>

					</tr>
					<tr>
						<td><strong><font color="red">
							{{this.contratoSolo.status}} 
							</font></strong>
						</td>
					</tr>

					<br>
					<tr>
						<td align="right" >
							Dato a incluir 
						</td>
						<td>
							<select id="loscampos"  v-model="seleccion"   v-on:change= 'agrega()'></select>
							<span>
								{{seleccion}}
							</span>
						</td>

					</tr>
					
				</table>
				<br>
				
				Leer un formato:
				<input type='file' accept='.for' v-on:change='leerFormato(event)' >

			<br>


			<div id="areaTexto">
				<textarea id='contenido' rows="100%" cols="100%" v-on:click='posicion()' v-on:keydown="keymonitor" >					
				</textarea>
			</div> 
			

			<div>
				<button id = 'bRemplazar' v-on:click='remplazar()'><b>Generar contrato</b></button> 
				<button id = 'bModificar' v-on:click='modificar()'><b>Ver formato</b></button>
				<button id = 'bGuardarFor' v-on:click='guardarFor(obtieneContenido())'><b>Guardar como Formato</b></button>
				<button id = 'bGuardarCon' v-on:click='guardarCon(obtieneContenido())'><b>Guardar Contrato lleno</b></button>
				<button v-on:click="imprimir('contenido')"><b>Imprimir o crear PDF</b></button>
			<br><br>
			</div>
		</div>
		<br>
	</div>
</template>

<script>
	import axios from 'axios';
	import contrat1  from './ContratosY-pre-contratos-buscar.vue'

	export default{
			name:'agrega-formato',
			components: {
				hijo1: contrat1
			},
			mounted(){
				this.leeLosCampos();
				document.getElementById('bModificar').hidden = true;
			},

			data(){
				return {
					seleccion: '',
					idContrato:'',
					contratos:'',
					contratoSolo: '',
					ultimaPosicion: '',
					contenidoEnFormato:'',
					buscar: false

				};
			},

			methods:{

				leerFormato: function(e) {
					// lee un archivo de texto de la computadora del usuario
					// pero si se vuelve a leer el mismo formato que se selecciono 
					// exactamente antes no lo vuelve a leer.
					var input = event.target;

				    var archivo = new FileReader();

				    archivo.onload = function () {
				        var text = archivo.result;
				        // graba el contenido de archivo en elemento contenido
				        var nodo = document.getElementById('contenido');
				        nodo.value = text;
				    };

				    archivo.readAsText(input.files[0]);

				},

			    formateaNumero(valor1) {
			        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
			    },

				formateaFecha: function (fecha) {
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				},

				obtieneContenido: function(){
					var elContenido = document.getElementById('contenido');
					return elContenido.value;
				},

				aBuscar(){
					this.buscar=true;
					document.getElementById('esVisible').style.height = "0";	
					document.getElementById('esVisible').style.visibility = "hidden";

				},

				recibeC: function(id, inum, pnum, ino, pno, gir, fam, subf, dueno, elmail, renta){

					this.leeContrato(id);
					this.buscar = false;
					document.getElementById('esVisible').style.visibility = "visible";
				},

				guardarFor: function(contenido){
					  	// valida si hay algo para guardar
					  	if (contenido.search('<<<')== -1){
					  		// no contiene campos de formato
					  		alert('\n\nIncluya algunos campos en el formato o vea el formato')
					  		return;
					  	}

					  	var nombre = prompt("\n\nNombre del formato ?");
					  	if (nombre == '') return;	

					  	// pide el nombre del archivo a guardar
					  	// crea y guarda un archivo de texto. E incluso lo baja al usuario
					  	var atag = document.createElement("a");
					  	var file = new Blob([contenido], {type: 'text/html'});
					  	atag.href = URL.createObjectURL(file);
					  	atag.download = nombre + '.for';
					  	atag.click();

				},

				guardarCon: function(contenido){
					  	// valida si hay algo para guardar
					  	if (contenido.length == 0) {
					  		// no contiene campos de formato
					  		alert('\n\n Contrato vacio');
					  		return;
					  	}

					  	if (contenido.search('<<<') != -1) {
					  		// no contiene campos de formato
					  		alert('\n\n Este es un formato, no es un contrato\n puede usar el boton GENERAR CONTRATO');
					  		return;
					  	}

					  	var nombre = prompt("Nombre del contrato ?");
					  	if (nombre == '') return;					  	
					  	// pide el nombre del archivo a guardar
					  	// crea y guarda un archivo de texto. E incluso lo baja al usuario
					  	var atag = document.createElement("a");
					  	var file = new Blob([contenido], {type: 'text/plain'});
					  	atag.href = URL.createObjectURL(file);
					  	atag.download = nombre + '.con';
					  	atag.click();

				},

				modificar: function(){
					document.getElementById('bModificar').hidden = true;
					document.getElementById('bRemplazar').hidden = false;
					var elContenido = document.getElementById('contenido');					
					elContenido.disabled = false;
					elContenido.value = this.contenidoEnFormato;

				},

				remplazar: function(){

					var elContenido = document.getElementById('contenido');
					var campos = document.getElementById('loscampos');

				  	if (elContenido.value.search('<<<')== -1){
				  		// no contiene campos de formato
				  		alert('\n\nIncluya algunos campos en el formato')
				  		return;
				  	} 

				  	var elContrato = document.getElementById('contra');
				  	if(elContrato.value <= 0){
				  		alert('\n\nSeleccione un contrato');
				  		return;
				  	}


					// guarda el contenido actual por si hay que hacer undo
					this.contenidoEnFormato = elContenido.value;	
					
					for(var i = 1; i < campos.length; i++){ // lee campo por campo del archivo encabezados
						var elCampo = campos[i].value;
						var elValor = this.contratoSolo[elCampo];//toma el valor de c/campo de este contrato

						
						var cadenaRemplazo = "<<<" + elCampo + ">>>";
						var nuevo;

						// crea la cadena a buscar globalmente para remplazar todas de una vez
						var cadenaRemplazo2 = new RegExp(cadenaRemplazo, "g" );

						if (elCampo.includes("importeMes") || elCampo.includes("saldo") ) {
							elValor = "$ " + this.formateaNumero(elValor); 
						}	


						if (elCampo.includes("fecha")) {
							elValor = this.formateaFecha(elValor); 
						}


						nuevo = elContenido.value.replace(cadenaRemplazo2, elValor);

						elContenido.value = nuevo;

						// inhabilito la modificacion del contenido
						elContenido.disabled = true;
						document.getElementById('bModificar').hidden = false;
						document.getElementById('bRemplazar').hidden = true;

					};

				},

				agrega: function()
				{
					var elContenido = document.getElementById('contenido');

					if (elContenido.disabled == true){
						alert('\n\n No se agregó. Debe estar en modo formato');
						return;
					}
					var primeraParte = elContenido.value.substring(0,parseInt(this.ultimaPosicion));
					var segundaParte = elContenido.value.substring(parseInt(this.ultimaPosicion), elContenido.length);

					// es importante que deje antes de los <<< y despues de >>> un espacio
					var todo1 = primeraParte + ' <<<' + this.seleccion + '>>> ' + segundaParte;
					elContenido.value = todo1;

					this.seleccion = "";

				},

				posicion: function () {
					// obtiene la posicion dentro del contenido
					var contiene = document.getElementById('contenido');	
					this.ultimaPosicion = contiene.selectionStart;				
				},

  				leeContrato: function(cualContrato){
					var elContrato1 = document.getElementById('contra');

  					// lee el registro del contrato
					axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id='+cualContrato)
	  		         	.then((respue) => {
	  		     			this.contratos = respue.data;
	  		     			this.contratoSolo = this.contratos[0];//el primer registro, el unico.
							elContrato1.value = this.contratoSolo.id;
	  			 	 	});

  				},

  				leeLosCampos: function(){
			     	var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeContratos.php';
			  		axios.get(cadena)
			  		     .then((respuesta) => {
			  		     	this.registrosTodos = respuesta.data;// recibe un objeto
			  		     	// llena el select de los campos
			  		     	this.llenaCampos();

			  			});
  				},	

			 	llenaCampos: function(){
					var loscampos1 =[];
				    // toma los titulos de los campos
					for (var nombreCampo in this.registrosTodos[0]){
						// lee campo por campo del registro primero y llena un arreglo con 
						// los nombres de cada campo
						loscampos1.push(nombreCampo);
					} 

					var selector2 = document.getElementById('loscampos');
					selector2.length=0; // lo limpia primero

					var c;
					for(c in loscampos1) { // lo llena
					    selector2.add(new Option(loscampos1[c]));
					};

				},	

			  	imprimir: function(divName) {
				     var printContents = document.getElementById(divName);

				     //var originalContents = document.body.innerHTML;
				     document.body.innerHTML = printContents.value;

				     // remplaza los saltos de renglon con hipertexto
				     document.body.innerHTML = document.body.innerHTML.replace(/\n/g, '<br>\n');

				     window.print();

				     // document.body.innerHTML = originalContents;					

					var router= this.$router;
          			router.push('/for-agerga');

				},

				keymonitor: function(evento){
  					this.posicion(); // actualiza la posicion del cursor				
 
					var contiene = document.getElementById('contenido');
					var anterior = contiene.value.substr(this.ultimaPosicion - 1, 1 );	
					var anterior3 = contiene.value.substr(this.ultimaPosicion - 3, 3 );	

					var posterior = contiene.value.substr(this.ultimaPosicion, 1 );
					var posicionCarAnterior = this.ultimaPosicion - 1;	
					var posicionCarPosterior = this.ultimaPosicion;	

			        var caracterTecleado = evento.key;
			        var c = this.ultimaPosicion;
			        var posicionInicial = c;
			        var caracteres = "";
			        var caracteres1 = "";
			        var caracteres2 = "";
			        var caracteres3 = "";

			        while(c >= 0 ){
			        	// termina de buscar si hay un caracter en blanco
			        	//if(contiene.value.substring(c, c ) === " ") c = -1;

			        	// si los 3 caracteres anteriores son <<< entonces encontro un campo y deja la edicion intacta
			        	caracteres = contiene.value.substring(c - 3, c );
			        	caracteres1 = contiene.value.substring(c - 2, c + 1);
			        	caracteres2 = contiene.value.substring(c - 1, c + 2);

			        	if (caracteres === "<<<" || caracteres1 === "<<<" || caracteres2 === "<<<" || caracteres3 === "<<<" ){
			        		// encontro un campo. Restituye entonces la edicion
			        		// devuelve el caracter eliminado a su lugar
			        		if(evento.key === "Backspace" ||  evento.key === "Enter"){
			        			var nuevoTexto = contiene.value.slice(0, posicionCarAnterior) + anterior + contiene.value.slice(posicionCarAnterior + 1);
			        			    // solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
									contiene.value = "#?*&&" + nuevoTexto;
									contiene.value = contiene.value.replace("#?*&&","");

									// cancela el evento
									evento.preventDefault();

									// posiciona el cursor antes de los signos <<<
									contiene.setSelectionRange(c-3,c-3);

			        		}

						    if(evento.key === "Delete"){
			        			var elCampo = contiene.value.substring(c - 3, posicionInicial);
			        			//alert (elCampo + "   " + posicionInicial + "   " + c);
			        			var borrarDesde = c - 3;
			        			var borrarHasta = 0;
			        			var cont = posicionInicial;

			        			while (cont <= contiene.value.length - 1){

			        				if (contiene.value.substring(cont, cont + 3) === ">>>"){

			        					borrarHasta = cont + 3 ;
			        					// ya encontro la terminacion del campo a borrar, ahora determina cual es el campo y lo borra. Le agrega caracteres basura para no confundir con otros campos
			        					var campoAborrar = contiene.value.substring(borrarDesde, borrarHasta) + "&4$#*";
										var nuevoTexto = contiene.value.slice(0, borrarDesde) + campoAborrar + contiene.value.slice(borrarHasta);
			        			    	// solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
			        			    	contiene.value = nuevoTexto;
										contiene.value = contiene.value.replace(campoAborrar,"");
			        					break; // termina el while

			        				}

			        				cont = cont +1;
			        			}

			        			// cancela el evento
			        			evento.preventDefault();
			        			// posiciona el mouse antes del campo que borro con delete
								contiene.setSelectionRange(borrarDesde,borrarDesde);

			        		}        		
			        			

			        		// checa si fue espacio u otro caracter
			        		if (evento.key != "Delete" && !evento.key != "Backspace" &&  !evento.key != "Enter" ){

			        			var nuevoTexto = contiene.value.slice(0, posicionCarAnterior + 1) + posterior + contiene.value.slice(posicionCarPosterior + 1);
		        			    // solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
								contiene.value = "#?*" + nuevoTexto;
								contiene.value = contiene.value.replace("#?*","");								
								// cancela el evento
		        				evento.preventDefault();
		        				// posiciona el mouse antes del campo que borro con delete
								contiene.setSelectionRange(c-3,c-3);
	
			        		}

			        	}

			        	c = c - 1;
			        	if(caracteres.includes(" ")) c = -1;	       			        	

        			}
      			


				}				

			}
	}
</script>


// WEBPACK FOOTER //
// src/Formato-agregar.vue